import React from "react";

const Star = ({ size, fillPercentage, className }) => (
  <span
    className={`${className}`}
    style={{ fontSize: size, fontFamily: "sans-serif" }}
  >
    <img
      src={`/images/pop-star-${fillPercentage}${".svg"}`}
      alt="star-disabled"
      width={size}
      height={size}
    />
  </span>
);

Star.defaultProps = {
  size: "19px",
  className: "",
  fillPercentage: 0
};

export default Star;
